/* Petits habillages globaux du thème v19, chargé par layout/theme.liquid :
   1. barre de progression sous les carrousels horizontaux sur mobile (comme davidprotein.com) ;
   2. fiches box : liste du contenu en carte noire, avec une astuce de dégustation par produit ;
   3. fiches produit : les phrases entre guillemets du bloc d'achat deviennent la carte « Pourquoi tu vas l'adorer » ;
   4. collections : texte et FAQ de la collection en bloc noir de marque (questions en accordéon). */
(function () {
  var SEL = '.sbt__track, .sbb__track, .sbr__track, .sbtr__grid';
  var Y = '#FFF746';
  var css = '.sb-progress{position:relative;width:min(64%,420px);height:3px;margin:22px auto 0;border-radius:3px;background:rgba(128,128,128,.35)}' +
    '.sb-progress span{position:absolute;top:0;bottom:0;left:0;border-radius:3px;background:currentColor;transition:left .15s linear}' +
    '@media (min-width:1000px){.sb-progress{display:none}}' +
    /* Astuces dans la liste des box */
    '.sb-boxlist h5{flex-wrap:wrap}.sb-boxlist .sb-tip{flex:1 1 auto;text-align:right;font-size:12px;font-weight:400;color:rgba(255,255,255,.6)}' +
    '.sb-boxlist .sb-tip::before{content:"Astuce · ";color:' + Y + ';font-weight:600}' +
    '@media (max-width:699px){.sb-boxlist .sb-tip{flex-basis:100%;padding-left:34px;text-align:left}}' +
    /* Bandeau de réassurance du bloc d'achat (remplace l'image) */
    '.sb-ts.sb-ts--mini{padding:14px 6px!important;border-radius:12px;background:#000!important}' +
    '.sb-ts--mini .sb-ts__in{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));text-align:center}' +
    '.sb-ts--mini .sb-ts__in>div{padding:2px 6px}.sb-ts--mini .sb-ts__in>div+div{border-left:1px solid rgba(255,255,255,.22)!important}' +
    '.sb-ts--mini .sb-ts__t,.sb-ts--mini .sb-ts__s{display:block;font-family:Georgia,"Times New Roman",serif;overflow-wrap:break-word}' +
    '.sb-ts--mini .sb-ts__t{font-size:15px!important;line-height:1.2;color:#fff!important}' +
    '.sb-ts--mini .sb-ts__s{margin-top:3px;font-style:italic;font-size:12.5px!important;line-height:1.3;color:#c9a227!important}' +
    /* Carte bénéfices du bloc d'achat */
    '.sb-buycard{margin:4px 0;padding:18px 18px 16px;border-radius:14px;background:#000;color:#fff}' +
    '.sb-buycard__h{margin:0 0 10px;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;opacity:.75}' +
    '.sb-buycard__list{display:grid;gap:0;margin:0!important;padding:0!important;list-style:none!important}' +
    '.sb-buycard__list li{display:flex;align-items:center;gap:12px;margin:0!important;padding:10px 0!important;border-bottom:1px dashed rgba(255,255,255,.2)}' +
    '.sb-buycard__list li::marker{content:none}' +
    '.sb-buycard__ic{flex:none;display:grid;place-items:center;width:32px;height:32px;border-radius:50%;background:' + Y + ';color:#000}.sb-buycard__ic svg{width:18px;height:18px}' +
    '.sb-buycard__list b{display:block;font-size:14px;font-weight:600;color:#fff}.sb-buycard__list small{display:block;margin-top:2px;font-size:12.5px;opacity:.7}' +
    '.sb-buycard__tip{margin:12px 0 0;padding:10px 12px;border-radius:10px;background:#1a1a1a;font-size:13px;line-height:1.45;color:rgba(255,255,255,.85)}' +
    '.sb-buycard__tip b{display:block;margin-bottom:2px;color:' + Y + ';font-size:11px;letter-spacing:.08em;text-transform:uppercase}' +
    /* Texte et FAQ des collections */
    '.sbcol .sbcol__about.sbab-on{background:#000!important;color:#fff!important;padding:clamp(48px,6vw,96px) 16px!important}' +
    '.sbcol .sbab-on .sbcol__about-in{max-width:1200px!important}' +
    '.sbab{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.1fr);gap:clamp(28px,5vw,88px);align-items:start;color:#fff}' +
    '.sbab__eyebrow{margin:0 0 14px!important;font-family:ui-monospace,Menlo,Consolas,monospace;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:' + Y + '}' +
    '.sbab__intro p{margin:0 0 14px!important;color:rgba(255,255,255,.78)!important;font-size:16px;line-height:1.65}' +
    '.sbab__intro p:first-of-type{color:#fff!important;font-family:var(--heading-font-family);font-size:clamp(19px,1.7vw,24px);line-height:1.4}' +
    '.sbab strong{color:#fff;font-weight:600}.sbab__intro p:first-of-type strong{color:' + Y + ';font-weight:inherit}' +
    '.sbab a{color:' + Y + '!important;text-decoration:underline;text-underline-offset:3px}' +
    '.sbab__faq h2{margin:0 0 14px!important;color:#fff!important;font-family:var(--heading-font-family);font-size:clamp(30px,3.4vw,50px);line-height:1.05}' +
    '.sbab__q{border-top:1px solid rgba(255,255,255,.18)}.sbab__q:last-of-type{border-bottom:1px solid rgba(255,255,255,.18)}' +
    '.sbab__q summary{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:18px 0;color:#fff;font-size:16px;font-weight:600;cursor:pointer;list-style:none}' +
    '.sbab__q summary::-webkit-details-marker{display:none}' +
    '.sbab__q summary::after{content:"+";flex:none;display:grid;place-items:center;width:30px;height:30px;border-radius:50%;background:' + Y + ';color:#000;font-size:18px;font-weight:600;line-height:1}' +
    '.sbab__q[open] summary::after{content:"\\2013"}' +
    '.sbab__a{margin:0!important;padding:0 46px 18px 0;color:rgba(255,255,255,.75)!important;font-size:15px;line-height:1.6}' +
    '.sbab__more{grid-column:1/-1;margin:0!important;padding-top:20px;border-top:1px dashed rgba(255,255,255,.2);color:rgba(255,255,255,.75)!important;font-size:15px}' +
    '@media (max-width:899px){.sbab{grid-template-columns:minmax(0,1fr)}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function attach(track) {
    if (track.dataset.sbProgress) return;
    track.dataset.sbProgress = '1';
    var bar = document.createElement('div');
    bar.className = 'sb-progress';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    bar.appendChild(thumb);
    track.insertAdjacentElement('afterend', bar);
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      bar.hidden = max < 8;
      var w = Math.max(12, track.clientWidth / track.scrollWidth * 100);
      thumb.style.width = w + '%';
      thumb.style.left = (max > 0 ? track.scrollLeft / max : 0) * (100 - w) + '%';
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Astuce de dégustation selon le produit de la box (l'ordre compte : « courbe » avant « saucisse »)
  function tipFor(t) {
    t = t.toLowerCase();
    if (/courb/.test(t)) return 'En biais, en éventail';
    if (/saucisson/.test(t)) return 'Tranches fines, en biais';
    if (/saucisse/.test(t)) return 'Tranches fines, en biais';
    if (/chorizo/.test(t) && /(fort|piquant)/.test(t)) return 'Avec une bière fraîche';
    if (/chorizo/.test(t)) return 'Sur du pain grillé';
    if (/fuet/.test(t)) return 'Rondelles fines, au couteau';
    if (/lomo/.test(t)) return "Très fin, filet d'huile d'olive";
    if (/tranch/.test(t)) return "Sachet sous l'eau chaude, gras transparent";
    if (/(jambon|serrano)/.test(t)) return 'Tranches au plus fin';
    return '';
  }

  // Fiches box : la liste du contenu (titres « 1 Saucisson… ») reçoit la classe sb-boxlist (carte noire, sb-david.css) et ses astuces.
  // Fiches produit : la liste de phrases entre guillemets est remplacée par la carte bénéfices (modèle dans sb-gallery-tiles).
  function productText() {
    var tpl = document.querySelector('template.sb-buycard-tpl');
    [].forEach.call(document.querySelectorAll('.product-info__text .prose'), function (p) {
      var h = p.querySelectorAll('h5');
      if (h.length < 2) return;
      if ([].every.call(h, function (x) { return /^\s*\d/.test(x.textContent); })) {
        p.classList.add('sb-boxlist');
        [].forEach.call(h, function (x) {
          var tip = tipFor(x.textContent);
          if (tip && !x.querySelector('.sb-tip')) x.insertAdjacentHTML('beforeend', '<span class="sb-tip">' + tip + '</span>');
        });
      } else if (tpl && !p.dataset.sbCard && [].every.call(h, function (x) { return /^\s*["“«]/.test(x.textContent); })) {
        p.dataset.sbCard = '1';
        p.style.display = 'none';
        p.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
      }
    });
    // Réassurance du bloc d'achat : l'image « secur_client_paiement » (chargée en 100 px, illisible) devient un bandeau texte noir.
    var simg = document.querySelector('.product-info img[src*="secur_client_paiement"]');
    if (simg && !document.querySelector('.sb-ts--mini')) {
      var blk = simg.closest('.product-info__block-item') || simg.parentElement;
      var src = document.querySelector('.sb-ts');
      var band;
      if (src) { band = src.cloneNode(true); }
      else {
        band = document.createElement('div');
        band.className = 'sb-ts';
        band.innerHTML = '<div class="sb-ts__in"><div><span class="sb-ts__t">Paiement</span><span class="sb-ts__s">100 % sécurisé</span></div><div><span class="sb-ts__t">Expédition</span><span class="sb-ts__s">sous 24 à 48 h</span></div><div><span class="sb-ts__t">Avis clients</span><span class="sb-ts__s">vérifiés</span></div></div>';
      }
      band.classList.add('sb-ts--mini');
      blk.innerHTML = '';
      blk.appendChild(band);
    }
    // Fiche sans ces phrases (ex. saucisse courbe) : la carte se place sous le prix.
    if (tpl && !document.querySelector('.sb-buycard') && !document.querySelector('.sb-boxlist')) {
      var price = document.querySelector('.product-info [data-block-type="price"], .product-info__price');
      var item = price && (price.closest('.product-info__block-item') || price);
      if (item) item.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    }
  }

  // Collections : intro + FAQ (questions en gras suivies d'un saut de ligne) en bloc noir de marque.
  // Titre de FAQ reconnu dans les trois langues : « Questions fréquentes », « Frequently asked questions », « Häufige Fragen ».
  function collectionAbout() {
    var box = document.querySelector('.sbcol__about');
    var inner = box && box.querySelector('.sbcol__about-in');
    if (!inner || inner.dataset.sbab) return;
    inner.dataset.sbab = '1';
    var nodes = [].slice.call(inner.children);
    var h2 = nodes.filter(function (n) { return n.tagName === 'H2' && /question|fragen|faq/i.test(n.textContent); })[0];
    var wrap = document.createElement('div');
    wrap.className = 'sbab';
    var intro = document.createElement('div');
    intro.className = 'sbab__intro';
    var lang = (document.documentElement.lang || 'fr').slice(0, 2);
    intro.innerHTML = '<div class="sbab__eyebrow">' + ({ en: 'The SaucBack guide', de: 'Der SaucBack-Ratgeber' }[lang] || 'Le guide SaucBack') + '</div>';
    var faq = document.createElement('div');
    faq.className = 'sbab__faq';
    var more = [];
    var inFaq = false;
    nodes.forEach(function (n) {
      if (n === h2) { inFaq = true; faq.appendChild(n); return; }
      if (!inFaq) { intro.appendChild(n); return; }
      var q = n.tagName === 'P' && n.firstElementChild && n.firstElementChild.tagName === 'STRONG' && n.querySelector('br');
      if (q) {
        var d = document.createElement('details');
        d.className = 'sbab__q';
        var s = document.createElement('summary');
        s.textContent = n.firstElementChild.textContent.trim();
        n.removeChild(n.firstElementChild);
        var br = n.querySelector('br');
        if (br && br === n.firstChild) n.removeChild(br);
        else if (br && n.firstChild && n.firstChild.nodeType === 3 && !n.firstChild.textContent.trim()) { n.removeChild(n.firstChild); if (n.firstChild === br) n.removeChild(br); }
        n.className = 'sbab__a';
        d.appendChild(s);
        d.appendChild(n);
        faq.appendChild(d);
      } else {
        n.classList.add('sbab__more');
        more.push(n);
      }
    });
    wrap.appendChild(intro);
    if (h2) wrap.appendChild(faq);
    else wrap.style.gridTemplateColumns = 'minmax(0,1fr)';
    more.forEach(function (m) { wrap.appendChild(m); });
    inner.appendChild(wrap);
    var first = faq.querySelector('details');
    if (first) first.open = true;
    box.classList.add('sbab-on');
  }

  function start() {
    [].forEach.call(document.querySelectorAll(SEL), attach);
    productText();
    collectionAbout();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
